<app-main-nav *ngIf="trans.loadedTranslations"></app-main-nav>
<div class="loader">
  <mat-progress-bar *ngIf="loading" mode="query"></mat-progress-bar>
</div>
<router-outlet *ngIf="trans.loadedTranslations"></router-outlet>
<app-footer *ngIf="trans.loadedTranslations"></app-footer>
